/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SkfWalletCode = {
    /**
     * Code ID
     */
    id?: string;
    /**
     * SKF wallet code
     */
    code?: string;
    /**
     * Code value in cents
     */
    value?: number;
    /**
     * Merchant identifier
     */
    merchantId?: string;
    /**
     * Code status (0=Available, 1=Used)
     */
    status?: SkfWalletCode.status;
    createdAt?: string;
    updatedAt?: string;
};
export namespace SkfWalletCode {
    /**
     * Code status (0=Available, 1=Used)
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
    }
}

